import { apiGet, apiPost, apiPatch } from '../api-client.ts';
import type { Ruolo } from '@/types/entities/user.ts';

interface UserSafe {
  id: number;
  email: string;
  nome: string;
  cognome: string;
  ruolo: Ruolo;
  id_fenice: number | null;
  is_active: number;
  created_at: string;
  last_login: string | null;
}

interface FeniceLookupResult {
  fenice: { id: number; nome: string; cognome: string } | null;
}

interface ListaUtentiResult {
  utenti: UserSafe[];
  count: number;
}

interface FeniceUserPreview {
  idFenice: number;
  nome: string;
  cognome: string;
  email: string;
  ruoloFenice: Ruolo;
  azione: 'nuovo' | 'aggiornare' | 'invariato';
  localId: number | null;
  ruoloLocale: Ruolo | null;
}

interface AnteprimaSyncResult {
  anteprima: FeniceUserPreview[];
}

interface SyncResult {
  creati: number;
  aggiornati: number;
  errori: string[];
}

export const utentiApi = {
  lista: () => apiGet<ListaUtentiResult>('utenti'),

  crea: (dati: { email: string; password: string; nome: string; cognome: string; ruolo: Ruolo; idFenice?: number | null }) =>
    apiPost<UserSafe>('utenti', dati),

  cambiaStato: (id: number, attivo: boolean) =>
    apiPatch<{ ok: true }>(`utenti/${id}/stato`, { attivo }),

  cambiaRuolo: (id: number, ruolo: Ruolo) =>
    apiPatch<{ ok: true }>(`utenti/${id}/ruolo`, { ruolo }),

  modificaAnagrafica: (id: number, nome: string, cognome: string, idFenice?: number | null) =>
    apiPatch<{ ok: true }>(`utenti/${id}/anagrafica`, { nome, cognome, ...(idFenice !== undefined ? { idFenice } : {}) }),

  feniceLookup: (email: string) =>
    apiGet<FeniceLookupResult>(`utenti/fenice/lookup?email=${encodeURIComponent(email)}`),

  resetPassword: (id: number, password: string) =>
    apiPatch<{ ok: true }>(`utenti/${id}/password`, { password }),

  feniceAnteprima: () =>
    apiPost<AnteprimaSyncResult>('utenti/fenice/anteprima', {}),

  feniceSync: (idFenice: number[]) =>
    apiPost<SyncResult>('utenti/fenice/sync', { idFenice }),
};
